import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { WorkerPoolsTableRow } from "../types";

const WorkerPoolsTableLabelsCell = ({
  item: row,
  ...cellProps
}: TableSimpleCellProps<WorkerPoolsTableRow>) => {
  const tags = row.kind === "private" ? row.workerPool.labels : [];

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={tags} />
    </TableSimpleCell>
  );
};

export default WorkerPoolsTableLabelsCell;
